import { cn } from "helpers/classNames";

type Props = {
  className?: string;
};

export default function Divider({ className }: Props) {
  return <div className={cn("w-full border-t border-gray-100", className)} />;
}
